import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CONFIG } from "../../config/config";
import { useCart } from "../../contexts/CartContext";
import { hasEarlyAccess, useEarlyAccessListener } from "../../utils/earlyAccess";
import PriceDisplay from "../PriceDisplay/PriceDisplay";
import { getPricePresentation } from "../../utils/pricing";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  useEarlyAccessListener();
  const { addToCart, loading } = useCart();
  const [selectedSize, setSelectedSize] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [showSizes, setShowSizes] = useState(false);
  const sizes = CONFIG.PRODUCT.SIZES;
  const showBestDeal = hasEarlyAccess();
  const price = getPricePresentation();

  const handleBuyNow = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!selectedSize) {
      setShowSizes(true);
      return;
    }

    setIsAdding(true);
    try {
      const catalogProduct = {
        id: product.id,
        name: product.name,
        images: [product.image],
        image: product.image,
        brand: product.brand,
      };
      await addToCart(catalogProduct, 1, selectedSize, "Black");
      setSelectedSize("");
      setShowSizes(false);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="basick-product-card">
      <Link to={`/product/${product.id}`} className="product-image-wrapper">
        <div className="product-image-container">
          <img
            src={product.image}
            alt={product.name}
            className="product-image"
          />

          <div className="product-badges">
            {product.isNew && <span className="badge new">NEW</span>}
            <span className="badge off">{price.discountPercent}% OFF</span>
            {showBestDeal && (
              <span className="badge sale">Best Deal</span>
            )}
          </div>
        </div>
      </Link>

      <div className="product-details">
        {product.brand && <div className="product-brand">{product.brand}</div>}

        <Link to={`/product/${product.id}`} className="product-name-link">
          <h3 className="product-name">{product.name}</h3>
        </Link>

        <div className="product-card-price-wrap">
          <PriceDisplay compact className="product-card-price" />
        </div>

        {showSizes && (
          <div className="size-selector">
            <span className="size-label">Select size</span>
            <div className="size-grid">
              {sizes.map((size) => (
                <button
                  key={size}
                  type="button"
                  className={`size-button ${
                    selectedSize === size ? "selected" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setSelectedSize(size);
                    setShowSizes(false);
                  }}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
        )}

        <button
          type="button"
          className={`add-to-cart-button buy-now-button ${isAdding || loading ? "adding" : ""}`}
          onClick={handleBuyNow}
          disabled={loading}
        >
          {isAdding || loading ? "Adding…" : CONFIG.CTA.BUY_NOW}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
